import React, {useEffect, useState} from 'react'
import classnames from 'classnames';
import {useDispatch} from 'react-redux'
import {showClearDataResultPopup, showCloseBlogResultPopup} from '../actions/popup';
import BlogDataPopupLayer from "../components/setting/blogData/BlogDataPopupLayer";
import {jsonResponseHandler} from "../utils/FetchHelper";
import {addPrefix} from "../utils/UriUtil";
import {isDaumBlogDomain} from "../utils/UriUtil";
import querystring from 'querystring';

function BlogClearDataForm() {
  const dispatch = useDispatch()

  function handleShowClearDataPopup(resultCode, resuleMessage) {
    dispatch(showClearDataResultPopup(resultCode, resuleMessage))
  }

  function sendClearDataRequest() {
    fetch(addPrefix("/manage/setting/blog/data/clear.json"), {
      method: 'POST',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        handleShowClearDataPopup(data.resultCode, data.resultMessage);
      })
      .catch(e => {
        console.log(e);
      })
  }

  return (
    <>
      <h3 className="tit_cont">데이터 관리</h3>
      <form className="wrap_set">
        <fieldset>
          <p className="noti_data">
            블로그의 데이터가 모두 삭제됩니다.<br/>
            데이터양에 따라 삭제 시간이 달라지며, 삭제가 진행되는 동안 블로그 접속이 원활하지 않을 수 있습니다.<br/>
            정말 삭제하시겠습니까?<br/>
          </p>
        </fieldset>
        <fieldset>
          <button type="button" className="btn_save" onClick={sendClearDataRequest}>삭제하기</button>
        </fieldset>
      </form>
    </>
  )
}

function BlogCloseForm() {
  const [agreeClosingBlog, setAgreeClosingBlog] = useState(false)

  const dispatch = useDispatch()
  function handleShowCloseBlogPopup(resultCode, resultMessage) {
    dispatch(showCloseBlogResultPopup(resultCode, resultMessage))
  }

  function sendCloseBlogRequest() {
    if (agreeClosingBlog) {
      fetch(addPrefix("/manage/setting/blog/data/close.json"), {
        method: 'POST',
        credentials: 'include'
      })
        .then(jsonResponseHandler(dispatch))
        .then(r => r.json())
        .then(data => {
          handleShowCloseBlogPopup(data.resultCode, data.resultMessage);
        })
        .catch(e => {
          console.error(e)
        })
    }
  }

  return (
    <>
      <h3 className="tit_cont">블로그 폐쇄</h3>
      <form className="wrap_set">
        <fieldset>
          <p className="noti_data">
            이 블로그를 폐쇄합니다.<br/>
            블로그를 폐쇄하면 블로그의 모든 데이터가 삭제되어 복원이 불가능합니다.<br/>
            사용하던 블로그 주소도 약 5일간 사용할 수 없습니다.
          </p>
          <div className="check_blog">
            <input type="checkbox" id="inpCheck1" className="inp_check" defaultChecked={false} onChange={e => setAgreeClosingBlog(e.target.checked)}/>
            <label htmlFor="inpCheck1" className="lab_check">
              <span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
              <span className="txt_check">위 안내 사항을 모두 확인하였으며, 폐쇄를 진행합니다.</span>
            </label>
          </div>
        </fieldset>
        <fieldset>
          <button type="button" className={classnames('btn_save', {btn_off: !agreeClosingBlog})} disabled={!agreeClosingBlog} onClick={sendCloseBlogRequest}>
            폐쇄하기
          </button>
        </fieldset>
      </form>
    </>
  )
}

function BlogCloseFormFromDaumblog() {
  const [agreeClosingBlog, setAgreeClosingBlog] = useState(false)
  const [insertBlogPass, setInsertBlogPass] = useState(false)
  const [ck1, setCk1] = useState(null)
  const [clientIp, setClientIp] = useState(null)
  const [password, setPassword] = useState(null)
  const [encPublicKey, setEncPublicKey] = useState(null)
  const loginId = window.initData.user != null ? window.initData.user.loginId.split("@")[0] : "";

  const dispatch = useDispatch()

  function init() {
    fetch(addPrefix("/manage/setting/blog/data/closeInfoFromDaumblog.json"), {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        setEncPublicKey(data.tempKey);
        setClientIp(data.clientIp);
      })
      .catch(e => {
        console.error(e);
      })
  }

  useEffect(() => {
    init()
  }, [])

  function handleShowCloseBlogPopup(resultCode, resultMessage) {
    dispatch(showCloseBlogResultPopup(resultCode, resultMessage))
  }

  function sendCloseBlogRequest() {
    if (agreeClosingBlog && insertBlogPass) {
      let proxyHost = window.appInfo.httpsProxyUrl;

      fetch(proxyHost, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type':'application/x-www-form-urlencoded'},
        body: querystring.stringify({
          "ck1": ck1,
          "ck3": password,
          "clientIp": clientIp
        })
      })
        .then(jsonResponseHandler(dispatch))
        .then(r => r.json())
        .then(data => {
          handleShowCloseBlogPopup(data.resultCode, data.resultMessage);
        })
        .catch(e => {
          console.error(e)
        })
    }
  }

  function handleCheckPassword(value){
    let blogPass = value;
    if (blogPass != null && blogPass.length > 0) {
      setInsertBlogPass(true);

      let crypt = new JSEncrypt();
      let tempKey = window.atob(encPublicKey);
      crypt.setKey(tempKey);

      var encValue = crypt.encrypt(value);
      setPassword(encValue);

      //temp val
      var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      var string_length = 15;
      var tempVal2 = '';
      for (var i=0; i<string_length; i++) {
        var rnum = Math.floor(Math.random() * chars.length);
        tempVal2 += chars.substring(rnum,rnum+1);
      }
      setCk1(tempVal2);

    } else {
      setInsertBlogPass(false);
    }
  }

  return (
    <>
      <h3 className="tit_cont">블로그 폐쇄</h3>
      <form className="wrap_set">
        <fieldset>
          <p className="noti_data">
            이 블로그를 폐쇄합니다.<br/>
            블로그를 폐쇄하면 블로그의 모든 데이터가 삭제되어 복원이 불가능합니다.
          </p>
          <div className="check_blog">
            <input type="checkbox" id="inpCheck1" className="inp_check" defaultChecked={false} onChange={e => setAgreeClosingBlog(e.target.checked)}/>
            <label htmlFor="inpCheck1" className="lab_check">
              <span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
              <span className="txt_check">위 안내 사항을 모두 확인하였으며, 폐쇄를 진행합니다.</span>
            </label>
          </div>
        </fieldset>
        <fieldset className="fld_name">
          <legend className="screen_out">개인정보</legend>
          <div className="lab_tf">
            <strong className="tit_set">Daum 아이디</strong>
            <input type="text" className="tf_blog" value={loginId} disabled />
          </div>
          <div className="lab_tf">
            <strong className="tit_set">비밀 번호</strong>
            <input type="password" className="tf_blog" onChange={e => handleCheckPassword(e.target.value)} ></input>
          </div>
        </fieldset>
        <fieldset>
          <button type="button" className={classnames('btn_save', {btn_off: !agreeClosingBlog || !insertBlogPass})} disabled={!agreeClosingBlog || !insertBlogPass} onClick={sendCloseBlogRequest}>
            폐쇄하기
          </button>
        </fieldset>
      </form>
    </>
  )
}

export default function BlogDataSettingApp() {
  return (
    <div className="inner_article manage_article">
      <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
      <div className="blog_data">
        { !isDaumBlogDomain() && (
          <>
            <BlogClearDataForm />
            <BlogCloseForm />
          </>
        )}
        { isDaumBlogDomain() && (
          <BlogCloseFormFromDaumblog />
        )}
      </div>
      <BlogDataPopupLayer/>
    </div>
  )
}
